/* Selected frame metadata, shared by the storefront and the no-write review. */
(function (root) {
  const fitCode = (fit) => ({ xxs: 'XXS', xs: 'XS', 'meget smal': 'XS', 'meget smalt': 'XS', smal: 'S', smalt: 'S', small: 'S', s: 'S', medium: 'M', m: 'M', bred: 'L', bredt: 'L', large: 'L', l: 'L', xl: 'XL', 'ekstra bred': 'XL', 'ekstra bredt': 'XL', xxl: 'XXL' }[String(fit || '').trim().toLowerCase()] || '');
  const sizeKey = (size, label) => {
    if (size?.sizeKey) return size.sizeKey;
    const dimensions = String(label || '').split(' - ').pop().match(/\d+/g);
    return dimensions ? dimensions.join('-') : String(label || '');
  };
  function preferredVariant(variants, fallbackId) {
    // Prefer M, then the closest standard fit. Break equal distances towards L.
    const priority = ['M', 'L', 'S', 'XL', 'XS', 'XXL', 'XXS'];
    const orderable = variants.filter((variant) => variant.available !== false);
    const candidates = orderable.length ? orderable : variants;
    let preferred;
    let bestRank = Infinity;
    candidates.forEach((variant) => {
      const fit = variant.size?.fit || String(variant.label || '').split(' - ')[0];
      const rank = priority.indexOf(fitCode(fit));
      if (rank >= 0 && rank < bestRank) {
        preferred = variant;
        bestRank = rank;
      }
    });
    return preferred || candidates.find((variant) => String(variant.id) === String(fallbackId)) || candidates[0];
  }
  function initialVariant(variants, { frameSize, variantId, fallbackId } = {}) {
    const requestedSize = frameSize && variants.find((variant) => sizeKey(variant.size, variant.label) === frameSize);
    const requestedVariant = variantId && variants.find((variant) => String(variant.id) === String(variantId));
    return requestedSize || requestedVariant || preferredVariant(variants, fallbackId);
  }
  function destinationUrl(href, key, currentUrl, sameLens) {
    const url = new URL(href, currentUrl);
    const current = new URL(currentUrl);
    url.searchParams.delete('variant');
    url.searchParams.set('frame-size', key);
    if (current.searchParams.get('custom-url') === 'true') {
      const allowed = ['glastykkelse', 'overfladebehandling', 'ekstravalg', 'solglas-type', 'farvevalg', 'recept'];
      if (sameLens) allowed.push('anvendelse', 'kvalitet');
      url.searchParams.set('custom-url', 'true');
      allowed.forEach((name) => {
        if (current.searchParams.has(name)) url.searchParams.set(name, current.searchParams.get(name));
      });
    }
    return url.pathname + url.search + url.hash;
  }
  const api = { fitCode, sizeKey, preferredVariant, initialVariant, destinationUrl };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  root.GlassifyFrameSizes = api;
  if (typeof document === 'undefined') return;

  function init(script) {
    if (script.dataset.initialized) return;
    const data = JSON.parse(script.textContent);
    const picker = document.querySelector(`product-variants[data-id="${data.sectionId}"]`);
    if (!picker) return;
    script.dataset.initialized = 'true';
    const variants = data.variants;
    const originalLinks = new Map();
    document.querySelectorAll('a.color-variant-link, [data-frame-lens-link]').forEach((link) => {
      originalLinks.set(link, link.getAttribute('href'));
      // Remove the legacy label's inline redirect which bypasses the updated link.
      link.querySelectorAll('[onclick]').forEach((label) => label.removeAttribute('onclick'));
    });
    function select(variant) {
      const container = picker.querySelector('.product-variant__container.size');
      const radio = Array.from(container?.querySelectorAll('input') || []).find((input) => input.value === variant.label);
      if (radio) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        const select = picker.querySelector('[data-js-product-variant-container="select"]');
        if (select) {
          select.value = variant.label;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }
    function update() {
      const id = picker.currentVariant?.id || document.querySelector(`#product-form-${data.sectionId} input[name="id"]`)?.value || data.initialId;
      const variant = variants.find((v) => String(v.id) === String(id));
      if (!variant) return;
      const size = variant.size;
      const activeVariant = picker.currentVariant || picker.getVariantData?.().find((v) => String(v.id) === String(id));
      if (activeVariant) {
        if (root.single_vison) {
          root.single_vison.product_frame_price = activeVariant.price;
          root.single_vison.product_frame_compare_at_price = activeVariant.compare_at_price || 0;
        }
        const priceInput = document.querySelector('#variant_price');
        const compareInput = document.querySelector('#variant_compare_at_price');
        if (priceInput) priceInput.value = activeVariant.price;
        if (compareInput) compareInput.value = activeVariant.compare_at_price || 0;
      }
      const key = sizeKey(size, variant.label);
      originalLinks.forEach((href, link) => {
        link.href = destinationUrl(href, key, location.href, link.classList.contains('color-variant-link'));
      });
      if (!size) {
        document.querySelector('#variant_price')?.dispatchEvent(new Event('change', { bubbles: true }));
        return; // Backward-compatible, unmigrated product.
      }
      document.querySelectorAll('[data-frame-measurement]').forEach((element) => {
        const value = size.measurements?.[element.dataset.frameMeasurement] || '';
        element.textContent = value;
        const row = element.closest('.frame-measurements-row, .sidebar-measurement-row');
        if (row) row.hidden = !value;
      });
      const code = fitCode(size.fit);
      document.querySelectorAll('[data-frame-fit]').forEach((element) => {
        element.textContent = code || size.fit;
        if (element.tagName === 'A') {
          const url = new URL(data.collectionUrl, location.origin);
          url.searchParams.set('filter.p.m.filters.fit', size.fit);
          element.href = url.pathname + url.search;
        }
      });
      document.querySelectorAll('[data-frame-fit-description]').forEach((element) => { element.hidden = true; });
      document.querySelectorAll('[data-current-size]').forEach((element) => {
        element.dataset.currentSize = code;
        const title = element.querySelector('strong');
        if (title) title.textContent = `Størrelse ${code || size.fit}`;
        const description = element.querySelector('p');
        if (description) description.textContent = `Størrelse: ${code || size.fit}`;
      });
      document.querySelectorAll('[data-size-row]').forEach((row) => {
        const current = row.dataset.size === code;
        row.classList.toggle('is-current-frame', current);
        let marker = row.querySelector('.table-marker-current');
        if (!marker && current) {
          marker = document.createElement('span');
          marker.className = 'table-marker table-marker-current';
          marker.textContent = 'Dette stel';
          row.querySelector('.comparison-cell')?.append(marker);
        }
        if (marker) marker.hidden = !current;
      });
      const page = picker.closest('product-page');
      if (page && size.averageOpticianPrice != null) page.dataset.averageOpticianPrice = String(Math.round(Number(size.averageOpticianPrice) * 100));
      // Recalculate the configured total through the existing pricing pipeline.
      document.querySelector('#variant_price')?.dispatchEvent(new Event('change', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('frame-size-change', { detail: { variant, size } }));
    }
    picker.addEventListener('VARIANT_CHANGE', update);
    const params = new URLSearchParams(location.search);
    const requestedKey = params.get('frame-size');
    const requestedId = params.get('variant');
    const desired = initialVariant(variants, {
      frameSize: requestedKey, variantId: requestedId, fallbackId: data.initialId
    });
    if (requestedKey) {
      const url = new URL(location.href);
      url.searchParams.delete('frame-size');
      history.replaceState({}, '', url);
    }
    if (desired && String(desired.id) !== String(picker.currentVariant?.id)) select(desired);
    update();
    window.addEventListener('popstate', () => {
      const params = new URLSearchParams(location.search);
      const desired = initialVariant(variants, {
        frameSize: params.get('frame-size'), variantId: params.get('variant'), fallbackId: data.initialId
      });
      if (desired && String(desired.id) !== String(picker.currentVariant?.id)) select(desired);
    });
  }
  const initAll = () => document.querySelectorAll('[data-frame-size-data]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})(typeof window === 'undefined' ? globalThis : window);
